import { AbstractControl, ValidatorFn } from '@angular/forms';

export class PasswordValidation {
  static SPECIAL_CHARS = {
    TURKISH:
      '\u00C7\u00E7\u011E\u011F\u0130\u0131\u00D6\u00F6\u015E\u015F\u00DC\u00FC',
    SPANISH:
      '\u00D1\u00F1\u00C1\u00E1\u00C9\u00E9\u00CD\u00ED\u00D3\u00F3\u00DA\u00FA',
    PORTUGUESE: '\u00C3\u00E3\u00C7\u00E7\u00D5\u00F5',
    RUSSIAN:
      '\u0410-\u0419\u0430-\u0439\u0401\u0451\u041A-\u0429\u043A-\u0449\u042A-\u042F\u044A-\u044F',
  };

  static passwordRegex = new RegExp(
    '^[a-zA-Z0-9' +
      PasswordValidation.SPECIAL_CHARS['TURKISH'] +
      PasswordValidation.SPECIAL_CHARS['RUSSIAN'] +
      ']{6,12}$'
  );

  static MatchPassword(AC: AbstractControl) {
    const password = AC.get('password').value;
    const confirmPassword = AC.get('confirmPassword').value;
    if (password !== confirmPassword) {
      return AC.get('confirmPassword').setErrors({ MatchPassword: true });
    }
    return null;
  }

  static PasswordRestriction(
    email: string,
    name: string,
    required = true
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!required && !control.value) {
        return null;
      }

      const inlengthRange =
        control.value.length >= 6 && control.value.length <= 12;
      if (!inlengthRange) {
        return { passwordRestriction: { inlengthRange: true } };
      }

      const noSpecialChars = this.passwordRegex.test(control.value);
      if (!noSpecialChars) {
        return { passwordRestriction: { specialChars: true } };
      }

      const includesNumber = /[0-9]/g.test(control.value);
      if (!includesNumber) {
        return { passwordRestriction: { includesNumber: true } };
      }

      const isEmail = control.value === email;
      if (isEmail) {
        return { passwordRestriction: { isEmail: true } };
      }

      const isName = control.value === name;
      if (isName) {
        return { passwordRestriction: { isName: true } };
      }

      return null;
    };
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/form-validations/password-validation.ts